import React, { Fragment, useState } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { Search } from 'react-feather';
import { Btn } from 'AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFormData } from 'Services/Features/Doctor/doctorSlice';
import { getDoctor } from 'Services/Features/Doctor/Utils/doctorUtils';
import { Link } from "react-router-dom";
import Select from 'react-select';

const FindDoctor = () => {
    const dispatch = useDispatch()
    const filters = useSelector(state => state.doctor.filters)
    const [selectedSortValue, setSelectedSortValue] = useState(null)

    const handleAdd = (e) => {
        dispatch(resetFormData());
    };


    const options = [
        { value: 'name', label: 'A-Z' },
        { value: '-name', label: 'Z-A' },
        { value: '-id', label: 'Terbaru' },
        { value: 'id', label: 'Terlama' },
    ];

    const handleSelectChangeSort = (selectedOption) => {
        setSelectedSortValue(selectedOption);
        const newFilters = {
            ...filters,
            'sort': selectedOption === null ? '' : selectedOption.value,
        }
        dispatch(setFilters(newFilters));
        dispatch(getDoctor(newFilters));
    }

    const handleClickSearch = (e) => {
        e.preventDefault()
        const newFilters = {
            ...filters,
            'page': 1,
        };
        dispatch(setFilters(newFilters));
        dispatch(getDoctor(newFilters));
    }

    const handleResetFilter = (e) => {
        e.preventDefault()
        const newFilters = {
            ...filters,
            'filter[id]': '',
            'filter[name]': '',
            'sort': '',
        }
        dispatch(setFilters(newFilters));
        dispatch(getDoctor(newFilters));
        setSelectedSortValue(null);
    }

    return (
        <Fragment>
            <Col xl="12">
                <div className="job-filter">
                    <div className="faq-form">
                        <Col className="d-flex justify-content-end align-items-center px-0" xs="12" sm="12" md="12" lg="12" xl="12">
                            <Row className="w-100">
                                <Col className="d-flex justify-content-start align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="6" style={{ whiteSpace: 'nowrap' }}>
                                    <Link
                                        to={`${process.env.PUBLIC_URL}/doctor/add`}
                                        onClick={handleAdd}>
                                        <Btn attrBtn={{ color: "primary" }}>
                                            <i className="fa fa-plus-circle fa-lg"></i> Tambah Dokter Baru
                                        </Btn>
                                    </Link>
                                </Col>
                                <Col className="d-flex justify-content-between align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <div className="position-relative w-100">
                                        <Input className="form-control" type="text" placeholder="Cari dokter.."
                                            value={filters['filter[name]']}
                                            onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                                            onChange={(e) => {
                                                dispatch(setFilters({
                                                    ...filters,
                                                    'filter[name]': e.target.value
                                                }));
                                            }}
                                        />
                                        <Search className="search-icon position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                                    </div>
                                </Col>
                                <Col className="mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <Select
                                        options={options}
                                        className="js-example-basic-single"
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder="Sort by.."
                                        onChange={handleSelectChangeSort}
                                        value={selectedSortValue}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center px-0" xs="12" sm="12" md="12" lg="12" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <Button color="warning me-2" onClick={handleResetFilter}>Reset</Button>
                                    <Button color="primary me-2" onClick={handleClickSearch}>Filter</Button>
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </div>
            </Col>
        </Fragment>
    );
};

export default FindDoctor;